// The tab icon says whether anything is waiting.
//
// Every icon link carries the `favicon` class and the swap is driven by the link's own `sizes`,
// so the set can grow without touching this file — except for the SVG, which has no pixel size.
// Before it existed, `sizes[0]` was interpolated straight into the filename; an SVG link would
// have resolved to `/favicon-badge-undefined.png` and the badge would have silently stopped
// appearing on exactly the icon modern browsers actually render.
// `getAttribute('sizes')`, not the `.sizes` DOMTokenList property: the property is a live
// browser-only interface, so the previous code could not be tested at all, and this reads the
// same string the markup declares.
const sizeOf = favicon => favicon.getAttribute('sizes');
const isVector = favicon => favicon.getAttribute('type') === 'image/svg+xml';

// The icons live in `public/` under permanent names, so a browser's favicon store — which is
// keyed by URL and revalidated close to never — will serve the mark it fetched the first time,
// forever. The layout appends a digest of the icon bytes to break that; these hrefs are rebuilt
// from scratch on every badge swap, so the digest has to be carried through or the first swap
// puts the permanently-cached URL back and undoes it.
const versionOf = favicon => favicon.dataset.version;

const versioned = (href, favicon) => {
  const version = versionOf(favicon);
  return version ? `${href}?v=${version}` : href;
};

const badgeHref = favicon =>
  versioned(
    isVector(favicon)
      ? '/favicon-badge.svg'
      : `/favicon-badge-${sizeOf(favicon)}.png`,
    favicon
  );

const plainHref = favicon =>
  versioned(
    isVector(favicon) ? '/favicon.svg' : `/favicon-${sizeOf(favicon)}.png`,
    favicon
  );

export const showBadgeOnFavicon = () => {
  document.querySelectorAll('.favicon').forEach(favicon => {
    favicon.href = badgeHref(favicon);
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        favicon.href = plainHref(favicon);
      });
    }
  });
};
